<div class="mentor-dropouts-grid-part">
	<grid-content [setup]="setup()" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="mentorDropouts()"></grid-content>
</div>